import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CatalogMemberMixin from "../../lib/ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../lib/ModelMixins/MappableMixin";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import mixTraits from "../../lib/Traits/mixTraits";
import CatalogMemberTraits from "../../lib/Traits/TraitsClasses/CatalogMemberTraits";
import MappableTraits from "../../lib/Traits/TraitsClasses/MappableTraits";
import UrlTraits from "../../lib/Traits/TraitsClasses/UrlTraits";
export default class SimpleCatalogItem extends CatalogMemberMixin(MappableMixin(CreateModel(mixTraits(UrlTraits, MappableTraits, CatalogMemberTraits)))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "mapItems", []);
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
}